module.exports = __webpack_public_path__ + "static/media/userImageNotAvilable.e5795a2c.png";